/* eslint-disable react/require-default-props */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import { InputSearch, PaperCustom } from './styles';

const useStyles = makeStyles(() => ({
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));

interface Props {
  setValue: any;
  value: string
  placeholder?: string;
}

const SearchBar: React.FC<Props> = ({ setValue, value, placeholder }) => {
  const classes = useStyles();

  const handleChange = (event: any) => {
    setValue(event.target.value);
  };

  return (
    <PaperCustom elevation={2} component="form" onSubmit={(e) => e.preventDefault()}>
      <InputSearch
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
      />
      <IconButton disabled className={classes.iconButton} aria-label="search">
        <SearchIcon />
      </IconButton>
    </PaperCustom>
  );
};
export default SearchBar;
